import script from "./AuthSite.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSite.vue?vue&type=script&setup=true&lang=js"

import "./AuthSite.vue?vue&type=style&index=0&id=f782a57c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f782a57c"]])

export default __exports__